import axios from 'axios';
import {useNavigate} from "react-router-dom";
//import {useLocation, useNavigate} from "react-router-dom";

const axiosInstance = axios.create({
        withCredentials: true,
        withXSRFToken: true,
        headers: {
            'X-Tour-Host': location.host,
          //  'Authorization': "code " + sessionStorage.getItem('tourCode'),
        }
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle unauthorized responses
        console.log("axiosInstance onRejected", window.location.pathname, error.response.data);
        if (error.response && error.response.status === 401) {
            // Redirect to the start screen
            sessionStorage.removeItem('tourCode');
            if (window.location.pathname !== "/") {
                window.location.href = `/?redirectTo=${window.location.pathname}`;
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;